import React, { useState, useEffect } from 'react';
import '../Login/Modal.css';
import '../Accounts/UserFormModal.css';

const API = process.env.REACT_APP_API_URL || '/api';

const ProfileModal = ({ show, onClose, user, onUserUpdate }) => {
  const [activeTab, setActiveTab] = useState('profile'); // profile | password
  const [profileData, setProfileData] = useState({ email: '', lineId: '' });
  const [passwordData, setPasswordData] = useState({ password: '', confirmPassword: '' });
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (show && user) {
      setProfileData({ email: user.email || '', lineId: user.lineId || '' });
      setPasswordData({ password: '', confirmPassword: '' });
      setErrors({});
      setMessage('');
      setActiveTab('profile');
    }
  }, [show, user]);

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setMessage('');
    const token = localStorage.getItem('token');
    try {
      const res = await fetch(`${API}/users/me/profile`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(profileData),
      });
      if (res.ok) {
        const updatedUser = await res.json();
        // 更新 localStorage 中的 user 資料
        const stored = JSON.parse(localStorage.getItem('user') || '{}');
        stored.email = updatedUser.email;
        stored.lineId = updatedUser.lineId;
        localStorage.setItem('user', JSON.stringify(stored));
        if (onUserUpdate) onUserUpdate(stored);
        setMessage('個人資料更新成功');
        // PM 07-19：更新資料重新儲存後需跳出提示，讓使用者明確知道有修改成功
        window.alert('資料已儲存');
      } else {
        const data = await res.json();
        setMessage(data.message || '更新失敗');
      }
    } catch {
      setMessage('更新失敗');
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setMessage('');
    const newErrors = {};
    if (!passwordData.password) newErrors.password = '請輸入新密碼';
    if (passwordData.password !== passwordData.confirmPassword) {
      newErrors.confirmPassword = '密碼不一致';
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    const token = localStorage.getItem('token');
    try {
      const res = await fetch(`${API}/users/${user._id}/password`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ password: passwordData.password }),
      });
      if (res.ok) {
        setMessage('密碼修改成功');
        setPasswordData({ password: '', confirmPassword: '' });
        // PM 07-19：修改密碼成功後同樣跳出提示，讓使用者明確知道有修改成功
        window.alert('資料已儲存');
      } else {
        const data = await res.json();
        setMessage(data.message || '密碼修改失敗');
      }
    } catch {
      setMessage('密碼修改失敗');
    }
  };

  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-lg" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>個人資料設定</h3>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          <div style={{ display: 'flex', gap: 'var(--spacing-sm)', marginBottom: 'var(--spacing-md)' }}>
            <button
              className={`btn btn-sm ${activeTab === 'profile' ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => { setActiveTab('profile'); setErrors({}); setMessage(''); }}
            >
              E-mail / 通訊方式
            </button>
            <button
              className={`btn btn-sm ${activeTab === 'password' ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => { setActiveTab('password'); setErrors({}); setMessage(''); }}
            >
              修改密碼
            </button>
          </div>

          {message && (
            <div style={{ padding: 'var(--spacing-sm) var(--spacing-md)', marginBottom: 'var(--spacing-md)', borderRadius: 'var(--radius-sm)', backgroundColor: message.includes('成功') ? 'var(--color-success-bg, #d4edda)' : 'var(--color-danger-bg, #f8d7da)', color: message.includes('成功') ? 'var(--color-success-text, #155724)' : 'var(--color-danger-text, #721c24)' }}>
              {message}
            </div>
          )}

          {activeTab === 'profile' && (
            <form onSubmit={handleProfileSubmit}>
              <div className="form-group">
                <label>E-mail</label>
                <input
                  type="email"
                  className="form-control"
                  value={profileData.email}
                  onChange={(e) => setProfileData({ ...profileData, email: e.target.value })}
                  placeholder="例如：celine@hunge.com.tw"
                />
              </div>
              <div className="form-group">
                <label>通訊方式</label>
                <input
                  type="text"
                  className="form-control"
                  value={profileData.lineId}
                  onChange={(e) => setProfileData({ ...profileData, lineId: e.target.value })}
                  placeholder="例如：LINE celine.chen"
                />
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={onClose}>取消</button>
                <button type="submit" className="btn btn-primary">儲存</button>
              </div>
            </form>
          )}

          {activeTab === 'password' && (
            <form onSubmit={handlePasswordSubmit}>
              <div className="form-group">
                <label>新密碼 *</label>
                <input
                  type="password"
                  className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                  value={passwordData.password}
                  onChange={(e) => setPasswordData({ ...passwordData, password: e.target.value })}
                />
                {errors.password && <div className="invalid-feedback">{errors.password}</div>}
              </div>
              <div className="form-group">
                <label>確認新密碼 *</label>
                <input
                  type="password"
                  className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
                  value={passwordData.confirmPassword}
                  onChange={(e) => setPasswordData({ ...passwordData, confirmPassword: e.target.value })}
                />
                {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword}</div>}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={onClose}>取消</button>
                <button type="submit" className="btn btn-primary">確認修改</button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileModal;
